<template>
	<div class='register-component'>
        <Media :kind="'video'" :src=currentUrl controls width="1000"/>
			<div class='register-form-box'>
				<table>
                    <thead>
                        <tr>
                            <td>Выберите раздел</td>
                        </tr>
                    </thead>
					<tbody>
						<tr v-for="item in tutorials" :key="item.id" @click="changeVideo($event)">
							<td :class="{ active: item.id == activeTutorial+1 }">{{item.name}}</td>
						</tr>
					</tbody>
				</table>
				<div class='register-btn-block'>
					<router-link to='/'>Вернуться</router-link>
				</div>
		</div>

	</div>
</template>

<script>
	import router from '@/router';
	const REGISTER = process.env.VUE_APP_ROOT_API + 'auth/register.php';
    import Media from '@dongido/vue-viaudio';
	import { mapState } from 'vuex';

	export default {
		name: 'RegisterComponent',
        components: {
            Media
        },
		data: () => ({
            tutorials: [
            {id: 1, name: '1. Начальный экран.mp4'},
            {id: 2, name: '2. Ввод ТАКСАЦИОННЫХ ОПИСАНИЙ.mp4'},
            {id: 3, name: '3. Создание ЛПО, Вкладка УЧАСТОК.mp4'},
            {id: 4, name: '4. Вкладка ГРАНИЦЫ И ПЛОЩАДЬ.mp4'},
            {id: 5, name: '5. Вкладка_ДАННЫЕ ОБСЛЕДОВАНИЯ_1_Дата, способ ЛПО.mp4'},
            {id: 6, name: '6.1. Вкладка_ДАННЫЕ ОБСЛЕДОВАНИЯ_2_СПЛОШНОЙ ПЕРЕЧЕТ.mp4'},
            {id: 7, name: '6.2. Вкладка_ДАННЫЕ ОБСЛЕДОВАНИЯ_2_КПП.mp4'},
            {id: 8, name: '6.3. Вкладка_ДАННЫЕ ОБСЛЕДОВАНИЯ_2_ЛЕНТЫ.mp4'},
            {id: 9, name: '6.4. Вкладка_ДАННЫЕ ОБСЛЕДОВАНИЯ_2_РЕЛАСКОПЫ.mp4'},
            {id: 10, name: '6.5. Вкладка_ДАННЫЕ ОБСЛЕДОВАНИЯ_2_БВ-50.mp4'},
            {id: 11, name: '6.6. Вкладка_ДАННЫЕ ОБСЛЕДОВАНИЯ_2_Виз. наз. ЛПО.mp4'},
            {id: 12, name: '7. Вкладка_ДАННЫЕ ОБСЛЕДОВАНИЯ_3_Модельные деревья.mp4'},
            {id: 13, name: '8. Вкладка_ДАННЫЕ ОБСЛЕДОВАНИЯ_4_Причины, соответствие ТО, очаг.mp4'},
            {id: 14, name: '9. Вкладка_ДАННЫЕ ОБСЛЕДОВАНИЯ_5_Мероприятия.mp4'},
            {id: 15, name: '10. Вкладка_РЕЗУЛЬТАТЫ ОБСЛЕДОВАНИЯ.mp4'},
            {id: 16, name: '11. Вкладка_АКТ (Выделы, аренда, абрис, приложения).mp4'},
            {id: 17, name: '12. Перевод в ЧИСТОВИК, Формирование акта ЛПО, строк в Реестры ГЛПМ.mp4'},
            {id: 18, name: '13.1. Нестандартные случаи_ТО_НЕ ПОКРЫТЫЕ ЛЕСОМ.mp4'},
            {id: 19, name: '13.2. Нестандартные случаи_ТО_НЕЛЕСНЫЕ ЗЕМЛИ.mp4'},
            {id: 20, name: '13.3. Несоответствие ТО и Ф при БВ-50 или Виз. наз. ЛПО.mp4'},
            {id: 21, name: '13.4. Выбор преобладающей породы.mp4'}
            ],
            activeTutorial: 0,
			login: null,
			user_name: null,
			filial_id: null,
			user_post: null
		}),
		computed: {
            currentUrl() {
                return 'https://services.rcfh.ru/lpo/videotutorial/'+ this.tutorials[this.activeTutorial].name;
            },
			...mapState({
				info_filials: state => state.catalogs.info_filials
			})
		},
		methods: {
            changeVideo(e) {
                //console.log(e.target.innerText)
                this.activeTutorial = this.tutorials.map(item => item.name).indexOf(e.target.innerText)
            },
			register() {

				let isIncorrect = false;

				if (this.login === null || this.login === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо ввести логин', life: 10000});
					isIncorrect = true;
				}
				if (this.user_name === null || this.user_name === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо ввести имя пользователя', life: 10000});
					isIncorrect = true;
				}
				if (this.filial_id === null || this.filial_id === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо выбрать филиал', life: 10000});
					isIncorrect = true;
				}
				if (this.user_post === null || this.user_post === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо ввести должность', life: 10000});
					isIncorrect = true;
				}
				if (isIncorrect) {
					return;
				}

				const form = new FormData();
				form.append('login', this.login);
				form.append('user_name', this.user_name);
				form.append('filial_id', this.filial_id);
				form.append('user_post', this.user_post);

				fetch(REGISTER, {
					method: 'post',
					body: form,
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					console.log(res)
					if ( res.user > 0) {
						this.$toast.add({severity: 'success', detail: 'Пользователь зарегистрирован (обновлен)', life: 10000});
					}
					if (res.code == 0) {
						this.$toast.add({severity: 'success', detail: 'Уведомление успешно отправлено на адрес электронной почты', life: 10000});
					} else {
						this.$toast.add({severity: 'error', detail: 'Письмо не отправлено', life: 10000});
					}
					
				})
				.catch(error => {
					this.$toast.add({severity: 'error', detail: 'Произошла ошибка', life: 10000});
				});
			}
		},
		created() {
			const catalogs = [ 'info_filials' ];
			this.$store.dispatch('loadCatalogs', catalogs);
		},
	};
</script>

<style scoped>
    .active {
        background: #eedddd;
    }
    tr {
        cursor: pointer;
    }
	.register-component {
        //max-width: 1000px;
		//height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
	}

	.register-form-box-outer {
        
		//height: 100%;
		//width: 560px;
		//margin: auto;

		/*background-color: black;*/
		//padding: 40px;

	}

	.register-form-box table {
		width: 100%;
	}

	.register-form-box {
        margin-top: 20px;
		display: flex;
        flex-direction: column;
        align-items: center;
        align-items: center;
        justify-content: center;
        width: 560px;
	}

	/*.back-to-login-block {
		position: absolute;
		left: 20px;
		bottom: 20px;
	}*/

	select {
		width: 100%;
	}

	table td {
		padding-bottom: 10px;
	}

	.label-col {
		text-align: right;
		padding-right: 20px;
		font-weight: bold;
	}

	input,
	select {
		height: 2rem;
		padding: 0 0.5rem;
	}

	input,
	select,
	table,
	button,
	.register-form-box {
		font-size: 1rem;
	}

	.register-btn-block {
		margin-top: 20px;
	}

	.register-btn-block::after {
		display: table;
		content: '';
		clear: both;
	}

	.register-btn {
		float: right;
	}

</style>